<form [formGroup]="emailForm">
    <input type="hidden" name="menuType" id="menuType" value="secure" />
    <div class="ontario-row">
        <div class="ontario-columns">
            <h2 id="pageTitle">{{'bss.user.email.update.title' | translate }}</h2>
            <hr>
        </div>
    </div>



    <div *ngIf="appError && !appSuccess" class="ontario-row" aria-live="polite" aria-atomic="true"
        id="pageLevelMessageId" #pageMsg>
        <div class="ontario-columns">
            <div class="ontario-alert ontario-alert--error ">
                <div class="ontario-alert__header">
                    <div class="ontario-alert__header-icon">
                        <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false"
                            sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </div>
                    <h2 class="ontario-alert__header-title ontario-h4">{{'bss.error' | translate}}</h2>
                </div>
                <div class="ontario-alert__body">
                    <p [innerHTML]="appErrorMessage | translate"></p>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="appSuccess && !appError" class="ontario-row" aria-live="polite" aria-atomic="true"
        id="pageLevelMessageId" #pageMsg>
        <div class="ontario-columns ontario-small-12">

            <div class="ontario-alert ontario-alert--success">
                <div class="ontario-alert__header">
                    <div class="ontario-alert__header-icon">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-success"></use>
                        </svg>
                    </div>
                    <h2 class="ontario-alert__header-title ontario-h4">{{'bss.success' | translate}}:</h2>
                </div>
                <div class="ontario-alert__body">
                    <p [innerHTML]="appSuccessMessage | translate"></p>
                </div>
            </div>
        </div>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12">
                <p>{{'bss.user.email.update.loseAccess'|translate}}</p>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-3">
                <label class="ontario-label" for="newEmail">
                    {{ 'bss.user.email.newAddress' | translate }}<span class="ontario-label__flag"> ({{'bss.required' |
                        translate }})</span>
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-9">
                <input class="ontario-input ontario-input--20-char-width" type="text" id="newEmail" tabindex="101"
                    title="{{ 'bss.user.email.err.newEmail.instruction' | translate }}" formControlName="newEmail"
                    appLowercase />

                <div id="newEmailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error "
                    *ngIf=" (submitted || emailForm.get('newEmail').touched || emailForm.get('newEmail').dirty) 
                        && (emailForm.get('newEmail').errors?.['required'])">
                    {{ 'bss.user.email.err.newEmail.required' | translate }}
                </div>

                <div id="newEmailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error "
                    *ngIf="(submitted || emailForm.get('newEmail').touched || emailForm.get('newEmail').dirty) && ( emailForm.get('newEmail')?.hasError('email') || emailForm.get('newEmail')?.hasError('invalidEmail') )">
                    {{'bss.user.email.err.newEmail.invalid' | translate}}
                </div>

                <div id="newEmailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error "
                    *ngIf="(submitted || emailForm.get('newEmail').touched || emailForm.get('newEmail').dirty) 
                        && (emailForm.get('newEmail').errors?.['restricted'])">
                    {{'bss.login.err.email.restricted' | translate}}
                </div>
<!-- 
                <div id="newEmailError" role="alert" aria-live="assertive" *ngIf="(submitted || emailForm.get('newEmail').touched || emailForm.get('newEmail').dirty) 
                        && emailForm.hasError('containsCurrentEmail')" class="ontario-alert ontario-alert--error">
                    {{'bss.user.email.err.email.contains.curent' | translate }}
                </div> -->

            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-3">
                <label class="ontario-label" for="confirmNewEmail">
                    {{ 'bss.user.email.confirmNewAddress' | translate }} <span class="ontario-label__flag">
                        ({{'bss.required' | translate }})</span>
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-9">
                <input class="ontario-input ontario-input--20-char-width" type="text" id="confirmNewEmail"
                    title="{{'bss.user.email.err.confirmEmail.instruction' | translate }}" tabindex="102"
                    formControlName="confirmNewEmail" appLowercase />

                <div id="confirmNewEmailError" role="alert" aria-live="assertive"
                    class="ontario-alert ontario-alert--error" *ngIf="(submitted || emailForm.get('confirmNewEmail').touched || emailForm.get('confirmNewEmail').dirty) 
                        && (emailForm.get('confirmNewEmail').errors?.['required'])">
                    {{'bss.user.email.err.confirmEmail.required' | translate}}
                </div>

                <div id="confirmNewEmailError" role="alert" aria-live="assertive"
                    class="ontario-alert ontario-alert--error"
                    *ngIf="(submitted || emailForm.get('confirmNewEmail').touched || emailForm.get('confirmNewEmail').dirty) 
                        && ( emailForm.get('confirmNewEmail')?.hasError('email') || emailForm.get('confirmNewEmail')?.hasError('invalidEmail') )">
                    {{'bss.user.email.err.confirmEmail.invalid' | translate}}
                </div>

                <div id="confirmNewEmailError" role="alert" aria-live="assertive" *ngIf="(submitted || emailForm.get('confirmNewEmail').touched 
                    || emailForm.get('confirmNewEmail').dirty) && emailForm.hasError('mismatchEmail')"
                    class="ontario-alert ontario-alert--error">
                    {{'bss.user.email.err.confirmEmail.mismatch' | translate }}
                </div>

            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-3">
                <label class="ontario-label" for="password" title="{{'bss.user.email.current.password' | translate}}">
                    {{ 'bss.user.email.current.password' | translate }} <span class="ontario-label__flag">
                        ({{'bss.required'
                        | translate }})</span>
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-9">
                <div class="toggle-container ontario-input--20-char-width">
                    <input tabindex="103" class="ontario-input ontario-input--20-char-width"
                        type="{{ showPassword === false ? 'password' : 'text' }}" id="password"
                        title="{{'bss.user.email.err.password.instruction' | translate}}" formControlName="password" />
                    <a tabindex="104" *ngIf="emailForm.get('password').value" (click)="togglePassword()"
                        id="passwordToggler"
                        title="{{ showPassword === false ? ('bss.user.email.showPassword.title' | translate) : ('bss.user.email.hidePassword.title' | translate) }}">
                        {{ showPassword === false ? ('bss.user.email.password.show' | translate) :
                        ('bss.user.email.password.hide' | translate) }}
                    </a>
                </div>

                <div id="passwordError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
                    *ngIf="(submitted || emailForm.get('password').touched || emailForm.get('password').dirty) 
                        && (emailForm.get('password').errors?.['required'])">
                    {{'bss.user.email.err.password.required' | translate}}
                </div>

            </div>
        </dd></dl>
    </div>

    <div *ngIf="this.emailAccess">
        <div class="ontario-row">
            <dl><dt></dt><dd>
                <div class="ontario-columns ontario-small-12">
                    <p>{{'bss.user.email.update.reminder'|translate}}</p>
                </div>
            </dd></dl>
            <dl><dt></dt><dd>
                <div class="ontario-columns ontario-small-12 ontario-medium-3">
                    <label class="ontario-label" for="otp" title="{{'bss.user.email.enter.otp' | translate}}">
                        {{ 'bss.user.email.enter.otp' | translate }} <span class="ontario-label__flag">
                            ({{'bss.required' |
                            translate }})</span>
                    </label>
                </div>
                <div class="ontario-columns ontario-small-12 ontario-medium-9">
                    <input class="ontario-input ontario-input--20-char-width" type="text" id="otp" tabindex="105"
                        title="{{ 'bss.user.email.err.otp.instruction' | translate }}" formControlName="otp"
                        minlength="8" maxlength="8" />

                    <div id="otpError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
                        *ngIf="(submitted || emailForm.get('otp').touched || emailForm.get('otp').dirty) 
                        && (emailForm.get('otp').errors?.['required'])">
                        {{'bss.user.email.err.otp.required' | translate}}
                    </div>

                    <div id="otpError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
                        *ngIf="(submitted || emailForm.get('otp').touched || emailForm.get('otp').dirty) 
                        && (emailForm.get('otp').errors?.['pattern'] || emailForm.get('otp').errors?.['minlength'] 
                        || emailForm.get('otp').errors?.['maxlength'] )">
                        {{'bss.user.email.err.otp.invalid' | translate}}
                    </div>

                </div>
            </dd></dl>
        </div>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-column ontario-small-12">
                <button class="ontario-button" [ngClass]="{'ontario-button--primary': !isSubmitting}"
                    title="{{'bss.user.email.update.submit.title' | translate}}" (keyup.enter)="onSave()" tabindex="106"
                    (click)="onSave()" [disabled]="isSubmitting" aria-describedby="pageLevelMessageId">
                    {{'bss.user.email.update.submit' | translate}}
                </button>
                <button class="ontario-button ontario-button--secondary"
                    title="{{'bss.user.email.update.cancel.title' | translate}}" tabindex="107" (click)="onCancel()">
                    {{'bss.user.email.update.cancel' | translate}}
                </button>
                <div *ngIf="this.emailAccess">
                    <p>{{'bss.resend.junk' | translate }}</p>

                    <p>{{'bss.user.email.didnt.receive.otp.message' | translate}}</p>
                    <button class="ontario-button" tabindex="108"
                        [ngClass]="{'ontario-button--secondary': !resendDisabled}"
                        title="{{'bss.resend.title' | translate}}" [disabled]="resendDisabled" (click)="resendOTP()"
                        [ngStyle]="{ 'cursor': resendDisabled ? 'not-allowed' : 'pointer' }"
                        aria-describedby="pageLevelMessageId">
                        {{'bss.resend' | translate}}
                    </button>
                </div>
            </div>
        </dd></dl>
    </div>
</form>

<dialog class="ontario-progress" #progressDialog>
    <app-progress></app-progress>
</dialog>